export default __webpack_public_path__ + "static/media/css.e3b16039.png";